<template>
  <v-app>
    <v-content>
      <v-container grid-list-md fluid>
        <Login
          @sucesso="sucessoLogin"
          v-if="!logged"
        />
        <Relatorio
          v-else
        />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Login from './components/Login'
import Relatorio from './components/Relatorio'

export default {
  name: 'App',
  components: {
    Login,
    Relatorio
  },
  data() {
    return {
      logged: false
    }
  },
  mounted() {
    if (localStorage.getItem('token') !== null) {
      let validate = parseInt(localStorage.getItem('validate'))
      if (isNaN(validate)) {
        validate = 0
      }
      if (validate > (new Date()).getTime()) {
        this.logged = true
      }
    }
  },
  methods: {
    sucessoLogin() {
      this.logged = true
    }
  }
}
</script>
